//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'NoveltyDecoration',
  components: {
    MdmStripe
  },
  props: {
    size: {
      type: MdmStripe.props.size.type,
      default: MdmStripe.props.size.default,
      validator: MdmStripe.props.size.validator
    }
  }
};